"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var arrow_left_icon_svg_1 = __importDefault(require("../assets/arrow-left-icon.svg"));
var arrow_right_icon_svg_1 = __importDefault(require("../assets/arrow-right-icon.svg"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        pageSelectGrid: {
            fontWeight: 500,
            color: '#767676',
            top: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '60px',
        },
        gridItemHorizontalPadding: {
            display: 'flex',
            justifyContent: 'middle',
            '&:first-child': {
                paddingRight: 34,
            },
            '&:last-child': {
                paddingLeft: 34,
            },
        },
        gridAlignVerticalMid: {
            display: 'flex',
            alignContent: 'space-around',
            flexWrap: 'wrap',
        },
    });
});
function LinkHistoryPagination(_a) {
    var pageCount = _a.pageCount, onChangePage = _a.onChangePage, page = _a.page;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Grid, { className: classes.pageSelectGrid },
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridItemHorizontalPadding },
            react_1.default.createElement(core_1.IconButton, { onClick: function () { return onChangePage(page - 1); }, disabled: page <= 0 },
                react_1.default.createElement("img", { src: arrow_left_icon_svg_1.default, alt: "Previous page", draggable: false }))),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridAlignVerticalMid }, t('text.pages') + " " + (page + 1) + " " + t('text.of') + " " + pageCount),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridItemHorizontalPadding },
            react_1.default.createElement(core_1.IconButton, { onClick: function () { return onChangePage(page + 1); }, disabled: pageCount <= page + 1 },
                react_1.default.createElement("img", { src: arrow_right_icon_svg_1.default, alt: "Next page", draggable: false })))));
}
exports.default = LinkHistoryPagination;
